import type { SpendCategoryType } from '/index';

export const capitalGoodsSpendCategories: SpendCategoryType[] = [
  {
    name: null,
    isPlaceholder: true,
    displayName: 'Select a spend category',
  },
  { name: 'computers', displayName: 'Computers, electronic and optical products' },
  { name: 'electrical', displayName: 'Electrical equipment' },
  { name: 'machinery', displayName: 'Machinery and equipment' },
  { name: 'motorVehicles', displayName: 'Motor vehicles, trailers and semi-trailers' },
  { name: 'ships', displayName: 'Ships and boats' },
  { name: 'air', displayName: 'Air and spacecraft and related machinery' },
  { name: 'otherTransport', displayName: 'Other transport equipment' },
  { name: 'furniture', displayName: 'Furniture' },
  { name: 'otherManufactured', displayName: 'Other manufactured goods' },
];
